export function shouldInvertBannerTextColor(bannerColor: string): boolean {
  switch (bannerColor.toLowerCase()) {
    case "green":
    case "blue":
      return true;
    default:
      return false;
  }
}
